import { Card } from 'antd';
import styled from 'styled-components';

export const ListCard = styled(Card)`
  overflow: hidden;
  max-height: calc(100vh - 175px);
  overflow: auto;
  .ant-card-body {
    padding: 24px 0;
  }
`;
